import PropTypes from 'prop-types';

const tilesProps = PropTypes.shape({
  explore: PropTypes.object,
  edit: PropTypes.object,
  complete: PropTypes.object,
  incomplete: PropTypes.object,
  origin: PropTypes.object,
});

export { tilesProps };
